import styled from 'styled-components';

import { COLORS } from 'theme';

import Tag from '../..';

export const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.black30};
    background: ${COLORS.black04};
    border-color: ${COLORS.black30};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
  }
`;
